import React from 'react';
import { IProps } from 'components/Slider/Item/types';

const Item: React.FC<IProps> = (props) => {
  return (
    <div className="swiper-slide">
      {props.children}
    </div>
  );
};

export default Item;
